import React, { useState, createRef, useRef, useEffect } from "react";
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Page404 from "app/not-found";
import { Button, Input, message, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";
import Resizer from "react-image-file-resizer";


const UploadProfile = styled(Upload)`
  .ant-upload {
    width: 50px !important;
    height: 50px !important;
  }
`;

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageAjouterArticle = () => {
    const { user } = useSelector((state) => state.user);
    const editorRef = createRef();
    const [contents, setContents] = useState(null);
    const [categorie, setCategorie] = useState('Articles');
    const [href, setHref] = useState("");
    const [image, setImage] = useState("");
    const [date, setDate] = useState(getDate());
    const [description, setDescription] = useState("");
    const [titre, setTitre] = useState("");
    const editor = useRef(null);
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [avatarFile, setAvatarFile] = useState(null);
    const titreRef = useRef(null); 
   
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    function getDate() {
        var date = new Date();
        const month = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];
        let jour = date.getDate();
        let mois = month[date.getMonth()];
        let annee = date.getFullYear();
        return jour + " " + mois + " " + annee;
    };

   

    async function getImageURL (file)  {
        const formData = new FormData();
        formData.append("image", file);
        console.log("Filename:" + file.name);
    
        try {
            const response = await axiosInstance.post("api/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data", 
                },
            });
            return response;
        } catch (err) {
            console.log("Erreur:" + err);
            return null;
        }
      
    };
    
    const handleAvatarChange = async (info) => {
        const file = info.file.originFileObj;
 
        if (file && file !== avatarFile) {
            try {
                setAvatarFile(file);
                const response = await getImageURL(file);
                setAvatarPreview(response.data); 
            } catch (err) {
                console.log(err);
            } 
        }
    };

    const categorieChange = (e) => {
        e.preventDefault();
        setCategorie(() => e.target.value);
    };

    const handleSave = (editorContent) => {
        console.log("titre: " + document.querySelector("#titre").value);
        saveArticle(editorContent);
    };

    const saveArticle = async (html) => {
        if (!(document.querySelector("#titre").value === "" ||
            document.querySelector("#image").value === "" ||
            document.querySelector("#description").value === "" ||
            document.querySelector("#date").value === "")) {
            try {
                const form = new FormData();
                form.append('href', "/article/" + document.querySelector("#href").value);
                form.append('titre', document.querySelector("#titre").value);
                form.append('html', html);
                form.append('image', document.querySelector("#image").src);
                form.append('categorie', document.querySelector("#categorie").value);
                form.append('date', document.querySelector("#date").value);
                form.append('description', document.querySelector("#description").value);
                const response = await axiosInstance.post("api/articles/add", form);

                alert("Enregistrement réussi!");
                window.location.reload();
            } catch (error) {
                alert("Envoie de: " + html.length * 2000 / 1024 / 1024 + "MB. Limite permise: 4.5MB");
                return;
            }
        } else {
            alert("Vous devez entrer tous les champs");
            return;
        }   
    }

    function remove_accents(str) {
        var strAccents = str.split('');
        var strAccentsOut = [];
        var strAccentsLen = strAccents.length;
        var accents = "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëÇçðÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
        var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeCcdDIIIIiiiiUUUUuuuuNnSsYyyZz";
        for (var y = 0; y < strAccentsLen; y++) {
            if (accents.indexOf(strAccents[y]) !== -1) {
                strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
            } else
                strAccentsOut[y] = strAccents[y];
        }
        strAccentsOut = strAccentsOut.join('');
        return strAccentsOut;
    }

    function getDateTimeYYYYMMDDHHMMSS() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');  // Mois : 01–12
    const day = String(now.getDate()).padStart(2, '0');         // Jour : 01–31
    const hours = String(now.getHours()).padStart(2, '0');      // Heures : 00–23
    const minutes = String(now.getMinutes()).padStart(2, '0');  // Minutes : 00–59
    const seconds = String(now.getSeconds()).padStart(2, '0');  // Secondes : 00–59

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
    }

    const titreChange = (e) => {
        e.preventDefault();
        setTitre(() => e.target.value);
        setHref(() => remove_accents(e.target.value).replace(/\s/g, '').replace(/[^0-9a-z]/gi, '')+getDateTimeYYYYMMDDHHMMSS());
    };

    const dateChange = (e) => {
        e.preventDefault();
        setDate(() => e.target.value);
    };

    const descriptionChange = (e) => {
        e.preventDefault();
        setDescription(() => e.target.value);
    };

    async function onImageUploadBefore (files, info, uploadHandler)  {
        console.log(files, info);

        const formData = new FormData();
        formData.append("image", files[0]);
        console.log("Filename:" + files[0].name);

        try {
            const response = await axiosInstance.post("api/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data", 
                },
            });

            const responseSunEditor = {
                result: [
                    {
                        url: response.data,
                        name: files[0].name,
                        size: files[0].size
                    }
                ]
            };
            uploadHandler(responseSunEditor);
        } catch (err) {
            console.log("Erreur:" + err);
        }
        return;
    };

    if (Object.keys(user).length === 0)
        return (<Page404 />)
    else
        return (
            <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
                <form name="frm">
                    <table>
                        <tbody>
                            <tr>
                                <td><p>Catégorie:</p></td>
                                <td>
                                    <select name="categorie" id="categorie" onChange={categorieChange} value={categorie}>
                                        <option value="Articles">Articles</option>
                                        <option value="Projets">Projets</option>
                                        <option value="Propositions">Propositions</option>
                                        <option value="Évenements">Événements</option>
                                        <option value="Conseils">Conseils d'arrondissement</option>
                                        <option value="Photos">Photos</option>
                                    </select>
                                </td>
                                <td><p>Titre:</p></td>
                                <td>
                                    <input ref={titreRef} value={titre} style={{ width: "400px" }} type="text" name="titre" id="titre" onChange={titreChange} />
                                </td>
                                <td><p>Image:</p></td>
                                <td>
                                    <UploadProfile
                                        name="avatar"
                                        listType="picture-circle"
                                        showUploadList={false}
                                        beforeUpload={() => true}
                                        onChange={handleAvatarChange}
                                        accept="image/*"
                                    >
                                        {avatarPreview ? (
                                            <img
                                                id="image"
                                                name="image"
                                                src={avatarPreview}
                                                alt="Avatar"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "50%",
                                                }}
                                            />
                                        ) : (
                                            <div>
                                                <PlusOutlined />
                                                <div style={{ marginTop: 8 }}>Envoyer</div>
                                            </div>
                                        )}
                                    </UploadProfile>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td><p>Href:</p></td>
                                <td><input id="href" name="href" readOnly style={{ width: "100%" }} type="text" value={href} /></td>
                                <td><p>Date:</p></td>
                                <td><p><input id="date" name="date" value={date} type="text" onChange={dateChange} /></p></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td><p>Description:</p></td>
                                <td colSpan={3}><input id="description" name="description" value={description} style={{ width: "100%" }} type="text" onChange={descriptionChange} /></td>
                            </tr>
                        </tbody>
                    </table>
                </form>
                <SunEditor
                    ref={editorRef}
                    getSunEditorInstance={getSunEditorInstance}
                    onSave={handleSave}
                    setOptions={{
                        buttonList: buttonList.complex,
                        iframe: false, // Désactiver l'iframe
                        height: "100vh", // Hauteur de l'éditeur
                    }}
                    onImageUploadBefore={onImageUploadBefore}
                />
            </div>
        );
};

export default PageAjouterArticle;
